/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MarketBarcodeResVo } from './MarketBarcodeResVo';
import {
    MarketBarcodeResVoFromJSON,
    MarketBarcodeResVoFromJSONTyped,
    MarketBarcodeResVoToJSON,
    MarketBarcodeResVoToJSONTyped,
} from './MarketBarcodeResVo';

/**
 * 
 * @export
 * @interface SkuResVo
 */
export interface SkuResVo {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof SkuResVo
     */
    id?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof SkuResVo
     */
    code?: string;
    /**
     * 重量（kg）
     * @type {number}
     * @memberof SkuResVo
     */
    wtKg?: number;
    /**
     * 长度（cm）
     * @type {number}
     * @memberof SkuResVo
     */
    length?: number;
    /**
     * 宽度（cm）
     * @type {number}
     * @memberof SkuResVo
     */
    width?: number;
    /**
     * 高度（cm）
     * @type {number}
     * @memberof SkuResVo
     */
    height?: number;
    /**
     * 体积（立方米）
     * @type {number}
     * @memberof SkuResVo
     */
    cbm?: number;
    /**
     * Logo图片URL
     * @type {string}
     * @memberof SkuResVo
     */
    logoImgUrl?: string;
    /**
     * 条码信息列表（一SKU多条码）
     * @type {Array<MarketBarcodeResVo>}
     * @memberof SkuResVo
     */
    barcodes?: Array<MarketBarcodeResVo>;
}

/**
 * Check if a given object implements the SkuResVo interface.
 */
export function instanceOfSkuResVo(value: object): value is SkuResVo {
    return true;
}

export function SkuResVoFromJSON(json: any): SkuResVo {
    return SkuResVoFromJSONTyped(json, false);
}

export function SkuResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'logoImgUrl': json['logoImgUrl'] == null ? undefined : json['logoImgUrl'],
        'barcodes': json['barcodes'] == null ? undefined : ((json['barcodes'] as Array<any>).map(MarketBarcodeResVoFromJSON)),
    };
}

export function SkuResVoToJSON(json: any): SkuResVo {
    return SkuResVoToJSONTyped(json, false);
}

export function SkuResVoToJSONTyped(value?: SkuResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'wtKg': value['wtKg'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
        'logoImgUrl': value['logoImgUrl'],
        'barcodes': value['barcodes'] == null ? undefined : ((value['barcodes'] as Array<any>).map(MarketBarcodeResVoToJSON)),
    };
}

